import "./styles/main.css";

import React,{useEffect} from "react";
// importing aos
import AOS from 'aos';
import 'aos/dist/aos.css';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Home from "./pages/Home";
import Projects from "./pages/Projects.js";
import ProjectPage from "./pages/ProjectPage.js";
import Contacts from "./pages/Contacts.js";

import ScrollToTop from "./utils/scrollToTop.js"

function App() {
  useEffect(() => {
    AOS.init();
  }, [])

  return (
    <div className="App" data-aos="zoom-in" data-aos-duration="500">
      <Router>
        <ScrollToTop />
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projectPage/:id" element={<ProjectPage />} />
          <Route path="/contacts" element={<Contacts />} />
        </Routes>

        <div data-aos="zoom-in" data-aos-duration="500">
        <Footer />
        </div>
      </Router>
    </div>
  );
}

export default App;
